import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { installRequestTracking } from "./utils/installRequestTracking";
import { loadFingerprintFeatures } from "./config/featureFlags";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import "primeflex/primeflex.css";
// import "antd/dist/reset.css";
import { SharedStateProvider } from './Pages/context/QcContext';

import { ConfirmDialog } from "primereact/confirmdialog";

installRequestTracking({ fetchTarget: window, axiosInstance: axios });

const root = ReactDOM.createRoot(document.getElementById("root"));
// Routes, menus and buttons read the fingerprint switches while rendering.
loadFingerprintFeatures().then(() => root.render(
  // <React.StrictMode>
    <PrimeReactProvider>
      <ConfirmDialog />
      <SharedStateProvider>
        <App />
      </SharedStateProvider>
    </PrimeReactProvider>
  // </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
